import { Skeleton, Table } from 'antd';

interface TableSkeletonProps {
  columns?: number;
  rows?: number;
}

export function TableSkeleton({ columns = 5, rows = 5 }: TableSkeletonProps) {
  const skeletonColumns = Array.from({ length: columns }, (_, i) => ({
    title: <Skeleton.Input active size="small" style={{ width: 80 }} />,
    dataIndex: `col${i}`,
    key: `col${i}`,
    render: () => <Skeleton.Input active size="small" style={{ width: '100%' }} />,
  }));

  const skeletonData = Array.from({ length: rows }, (_, i) => ({
    key: i,
    ...Object.fromEntries(
      Array.from({ length: columns }, (_, j) => [`col${j}`, null])
    ),
  }));

  return (
    <Table
      columns={skeletonColumns}
      dataSource={skeletonData}
      pagination={false}
      size="middle"
    />
  );
}
